// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kddrX_nK1N4RSYyrAML2{flex-direction:column;gap:12px;display:flex}.kddrX_nK1N4RSYyrAML2 .nONR53U2SLgJ99Eo3s_h{border-color:var(--content-negative-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `kddrX_nK1N4RSYyrAML2`,
	"selectError": `nONR53U2SLgJ99Eo3s_h`
};
export default ___CSS_LOADER_EXPORT___;
